import React from 'react';
import SubjectPage from './../../subjects/SubjectPage';

function Syllabus() {
  
    const pageTitleText = "NEET 2027 Syllabus by NTA";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="syllabus" 
      />

    </>
  );
}

export default Syllabus;